var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./commentCard.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-ca214aaa!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./commentCard.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/onlineRoundtables/components/commentCard/commentCard.vue
// module id = 265
// module chunks = 61